"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _AnalyticsPeriod = _interopRequireDefault(require("hub-pickers-lib/constants/AnalyticsPeriod"));

var _default = (0, _immutable.Record)({
  id: 0,
  frequency: _AnalyticsPeriod.default.WEEKLY,
  totals: {
    currentPeriodSessions: null,
    previousPeriodSessions: null,
    currentPeriodLeads: null,
    previousPeriodLeads: null
  },
  changeInSessions: null,
  changeInLeads: null
}, 'Analytics');

exports.default = _default;
module.exports = exports.default;